"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../../helpers/translations");

var _Modal = _interopRequireDefault(require("../Modal"));

var _LoadingOverlay = _interopRequireDefault(require("../LoadingOverlay"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* Review_Modal
*
*/
function ReviewModal(_ref) {
  var show = _ref.show,
      title = _ref.title,
      body = _ref.body,
      onApprove = _ref.onApprove,
      onModalClose = _ref.onModalClose,
      onReject = _ref.onReject,
      isLoading = _ref.isLoading,
      maxWidth = _ref.maxWidth,
      fullWidth = _ref.fullWidth;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: show,
    title: title,
    onCloseModal: onModalClose,
    maxWidth: maxWidth,
    fullWidth: fullWidth,
    isLoading: isLoading,
    includeLeftCancelBtn: true,
    actionButtons: [{
      label: (0, _translations.getTranslations)('btn_reject'),
      action: onReject,
      loading: isLoading
    }, {
      label: (0, _translations.getTranslations)('btn_approve'),
      action: onApprove,
      loading: isLoading,
      buttonType: 'contained'
    }]
  }, /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
    show: isLoading || false,
    width: "100%"
  }, body));
}

ReviewModal.propTypes = {
  show: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  body: _propTypes["default"].node.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  onModalClose: _propTypes["default"].func.isRequired,
  onReject: _propTypes["default"].func.isRequired,
  isLoading: _propTypes["default"].bool,
  maxWidth: _propTypes["default"].oneOf(['sm', 'md', 'lg', false]),
  fullWidth: _propTypes["default"].bool
};
var _default = ReviewModal;
exports["default"] = _default;